import isPlainValue from '../verifiers/is-plain-value';

const combineTargetValues = (currentValue, newValue) =>
  !isPlainValue(currentValue) && !isPlainValue(newValue)
    ? { ...currentValue, ...newValue }
    : newValue;

const combineTargets = (currentTargets = {}, targets) =>
  Object.entries(targets).reduce(
    (combinedTargets, [target, value]) => ({
      ...combinedTargets,
      [target]: combineTargetValues(combinedTargets[target], value),
    }),
    { ...currentTargets }
  );

const combineBatches = (batches = []) =>
  batches.reduce(
    (currentBatch, batch) => ({
      ...currentBatch,
      ...Object.fromEntries(
        Object.entries(batch).map(([elementId, targets]) => [
          elementId,
          combineTargets(currentBatch[elementId], targets),
        ])
      ),
    }),
    {}
  );

export default combineBatches;
